/* ==========================================================================
   Occasion picker on a phone

   Desktop keeps the three cards. On a phone they become a dropdown: the trigger
   shows what is chosen — photo, label, name, price — and the cards themselves
   are the menu. Nothing is duplicated: one set of markup, one selection, two
   layouts, so a choice made at either size behaves the same.

   The theme re-renders this block on every variant change, so everything is
   delegated from the document and the trigger is re-read rather than cached.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function trigger() {
    return document.getElementById('packagingTrigger');
  }

  function cards() {
    return document.getElementById('packagingCards');
  }

  function isPhone() {
    return window.matchMedia && window.matchMedia(MOBILE).matches;
  }

  // What the trigger says is read off the selected card, so the two can never
  // disagree — including after the section is re-rendered by a variant change.
  /* What the trigger says is read off the selected card, so the two can never
     disagree — including after the section is re-rendered by a variant change.

     THE TRAP: the trigger lives inside <variant-selects>, which is the subtree
     the observer below watches. Writing into it from here re-fired the observer,
     which called this again — an infinite loop that locked the page on every
     product carrying these cards. So the observer is detached for the duration
     of the write, and nothing is written unless it actually changed.          */
  var observer = null;
  var watching = null;

  function detach() {
    if (observer && watching) observer.disconnect();
  }

  function attach() {
    if (observer && watching) {
      observer.observe(watching, { childList: true, subtree: true });
    }
  }

  function paint() {
    var btn = trigger();
    var host = cards();
    if (!btn || !host) return;

    var card = host.querySelector('.pkg-card.selected') || host.querySelector('.pkg-card');
    if (!card) return;

    var img = card.querySelector('.pkg-card-media img');
    var wantSrc = img ? img.currentSrc || img.src : '';
    var media = btn.querySelector('.pkg-trigger-media');
    var have = media ? media.querySelector('img') : null;

    var pairs = [
      ['.pkg-trigger-eyebrow', '.pkg-card-eyebrow'],
      ['.pkg-trigger-name', '.pkg-card-title'],
      ['.pkg-trigger-price', '.pkg-card-price']
    ];

    var writes = [];
    pairs.forEach(function (pair) {
      var target = btn.querySelector(pair[0]);
      var source = card.querySelector(pair[1]);
      if (!target) return;
      var next = source ? source.textContent.trim() : '';
      if (target.textContent !== next) writes.push([target, next]);
    });

    var imageChanged = !!media && (have ? have.src !== wantSrc : !!wantSrc);
    if (!writes.length && !imageChanged) return; // Nothing to do: do not touch the DOM.

    detach();

    writes.forEach(function (write) {
      write[0].textContent = write[1];
    });

    if (imageChanged) {
      media.innerHTML = '';
      if (wantSrc) {
        var copy = document.createElement('img');
        copy.src = wantSrc;
        copy.alt = '';
        media.appendChild(copy);
      }
    }

    attach();
  }

  function close() {
    var btn = trigger();
    var host = cards();
    if (host) host.classList.remove('open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('#packagingTrigger');
    if (btn) {
      if (!isPhone()) return;
      event.preventDefault();
      var host = cards();
      if (!host) return;
      var open = host.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    // Choosing closes the list. The card's own handler still makes the
    // selection; this only puts the menu away and updates the trigger.
    var card = event.target.closest && event.target.closest('#packagingCards .pkg-card');
    if (card) {
      if (!isPhone()) return;
      setTimeout(function () {
        paint();
        close();
      }, 0);
      return;
    }

    if (isPhone()) {
      var host2 = cards();
      if (host2 && host2.classList.contains('open') && !event.target.closest('#packagingCards')) close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  // The block is replaced wholesale on a variant change; repaint when it is.
  // Coalesced onto a frame so a burst of app-driven mutations costs one repaint,
  // not one per record.
  function watch() {
    paint();
    if (typeof MutationObserver === 'undefined') return;

    watching = document.querySelector('variant-selects') || document.body;

    var queued = false;
    observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        paint();
      });
    });
    attach();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
